__turbopack_context__.v({
  "actions": "page-module__wtSYKa__actions",
  "bestCost": "page-module__wtSYKa__bestCost",
  "brand": "page-module__wtSYKa__brand",
  "brandMark": "page-module__wtSYKa__brandMark",
  "chartCard": "page-module__wtSYKa__chartCard",
  "chartEmpty": "page-module__wtSYKa__chartEmpty",
  "chartError": "page-module__wtSYKa__chartError",
  "chartShell": "page-module__wtSYKa__chartShell",
  "chartToolbar": "page-module__wtSYKa__chartToolbar",
  "contractGrid": "page-module__wtSYKa__contractGrid",
  "contractSection": "page-module__wtSYKa__contractSection",
  "costList": "page-module__wtSYKa__costList",
  "costRow": "page-module__wtSYKa__costRow",
  "dashboardLink": "page-module__wtSYKa__dashboardLink",
  "disabledNav": "page-module__wtSYKa__disabledNav",
  "eyebrow": "page-module__wtSYKa__eyebrow",
  "featuredContract": "page-module__wtSYKa__featuredContract",
  "finePrint": "page-module__wtSYKa__finePrint",
  "footer": "page-module__wtSYKa__footer",
  "header": "page-module__wtSYKa__header",
  "headerActions": "page-module__wtSYKa__headerActions",
  "hero": "page-module__wtSYKa__hero",
  "heroCopy": "page-module__wtSYKa__heroCopy",
  "heroStats": "page-module__wtSYKa__heroStats",
  "heroText": "page-module__wtSYKa__heroText",
  "legend": "page-module__wtSYKa__legend",
  "legendCheap": "page-module__wtSYKa__legendCheap",
  "legendHigh": "page-module__wtSYKa__legendHigh",
  "legendMid": "page-module__wtSYKa__legendMid",
  "legendNegative": "page-module__wtSYKa__legendNegative",
  "nav": "page-module__wtSYKa__nav",
  "page": "page-module__wtSYKa__page",
  "panelKicker": "page-module__wtSYKa__panelKicker",
  "panelMetrics": "page-module__wtSYKa__panelMetrics",
  "panelTop": "page-module__wtSYKa__panelTop",
  "previewChart": "page-module__wtSYKa__previewChart",
  "previewPanel": "page-module__wtSYKa__previewPanel",
  "previewRows": "page-module__wtSYKa__previewRows",
  "previewTop": "page-module__wtSYKa__previewTop",
  "priceGrid": "page-module__wtSYKa__priceGrid",
  "priceSection": "page-module__wtSYKa__priceSection",
  "priceSummary": "page-module__wtSYKa__priceSummary",
  "priceTooltip": "page-module__wtSYKa__priceTooltip",
  "primaryButton": "page-module__wtSYKa__primaryButton",
  "productPreview": "page-module__wtSYKa__productPreview",
  "resultPanel": "page-module__wtSYKa__resultPanel",
  "secondaryButton": "page-module__wtSYKa__secondaryButton",
  "sectionHeading": "page-module__wtSYKa__sectionHeading",
  "summaryCards": "page-module__wtSYKa__summaryCards",
  "summaryHighlight": "page-module__wtSYKa__summaryHighlight",
  "useCaseGrid": "page-module__wtSYKa__useCaseGrid",
  "useCases": "page-module__wtSYKa__useCases",
  "workflowGrid": "page-module__wtSYKa__workflowGrid",
  "workflowSection": "page-module__wtSYKa__workflowSection",
});
